import React, { useEffect, useState } from 'react';
import UserSettings from '@mysimpledb/shared/components/Account/UserSettings';
import { useUserSettingsContext } from '@mysimpledb/shared/context/UserSettingsContext';

const defaultSearchSettings = {
  broad_search_title: true,
  broad_search_keywords: true,
  broad_search_category: true,
  broad_search_detail: false,
};

const SiteSettingsWeb = ({ token: propToken }) => {
  const token = propToken || localStorage.getItem('token');

  const {
    settings: loadedSettings,
    loading,
    updating,
    error,
    saveSettings,
  } = useUserSettingsContext();

  const [settings, setSettings] = useState(defaultSearchSettings);

  useEffect(() => {
    if (!loadedSettings) return;

    setSettings({
      broad_search_title: !!loadedSettings.broad_search_title,
      broad_search_keywords: !!loadedSettings.broad_search_keywords,
      broad_search_category: !!loadedSettings.broad_search_category,
      broad_search_detail: !!loadedSettings.broad_search_detail,
    });
  }, [loadedSettings]);

  const handleFieldChange = (field, value) => {
    setSettings((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = async () => {
    await saveSettings({
      broadSearchTitle: settings.broad_search_title,
      broadSearchKeywords: settings.broad_search_keywords,
      broadSearchCategory: settings.broad_search_category,
      broadSearchDetail: settings.broad_search_detail,
    });
  };

  if (loading) {
    return <div style={{ padding: '24px' }}>Loading settings...</div>;
  }

  return (
    <UserSettings
      settings={settings}
      errors={{
        load: error,
        save: error,
      }}
      loading={updating}
      onFieldChange={handleFieldChange}
      onSave={handleSave}
    />
  );
};

export default SiteSettingsWeb;
